export const useGTMTracking = (trackingId: string, url: string) => {
  return {
    trackingProps: {
      className: trackingId,
      onClick: () => window.open(url, '_blank'),
    },
  }
}
